import React from 'react'
import { Box, Grid, Button, Typography } from '@mui/material'
import HeaderBox from '../../../components/HeaderBox';
import PrintIcon from '@mui/icons-material/Print';
import buttonStyle from '../../../styles/buttonStyle'
import { useNavigate } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import { useReactToPrint } from "react-to-print";
import { useRef } from 'react';



const boxStyle = {
  root: {
    backgroundColor: 'white', 
    borderRadius: '5px',
    padding: 1
  },
};

function InvoiceBill() {
    const navigate = useNavigate()
    const conponentPDF= useRef();
    const generatePDF= useReactToPrint({
        content: ()=>conponentPDF.current,
        documentTitle:"Userdata",
        onAfterPrint:()=>alert("Data saved in PDF")
    });
    
    // const [isParts, setIsParts] = useState(false)
    return (
      
      <Box mt={2} >
        <Grid container spacing={1}>
        <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>INVOICE BILL</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end' >
            <Button sx={buttonStyle.root} onClick={ generatePDF}><PrintIcon />Print</Button>&nbsp;
            <Button sx={buttonStyle.root} onClick={() => navigate('/Invoice_Genaration')}>Cancel</Button>
          </Grid>
          </Grid>
        </Grid>
        <div ref={conponentPDF} style={{width:'100%'}}>
          <Grid item xs={12} mt={1}>
            <Box>
              <form>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <HeaderBox title="Invoice" />
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={boxStyle.root}>
                      <Grid container spacing={1}>
                      <Grid item xs={6}> One Stop Auto Center </Grid>
                      <Grid item xs={6}fontWeight='bold'> Invoice No : 15973 </Grid>
                        <Grid item xs={6}> Unit 1.71-73</Grid>
                        <Grid item xs={6}> Date :  </Grid>
                        <Grid item xs={6}> Nathan Way </Grid>
                        <Grid item xs={6}> VAT No : </Grid>
                        <Grid item xs={6}> Thamesmead </Grid>
                        <Grid item xs={6}> Tel No : </Grid>
                        <Grid item xs={6}> London </Grid>
                        <Grid item xs={6}> Mob No : </Grid>
                        <Grid item xs={6} > SE280BQ </Grid>
                        <Grid item xs={6} > Email:  </Grid>
                        <Grid item xs={6} ></Grid>
                        <Grid item xs={6} >Website:</Grid>
                        <Grid item xs={6} fontWeight='bold'> Mr John </Grid>
                        <Grid item xs={6} ></Grid>
                        <Grid item xs={12} sm={6} md={1} fontWeight='bold'> AccNo : </Grid>
                        <Grid item xs={12} sm={6} md={11} > ACC01557 </Grid>
                        <Grid item xs={12} sm={6} md={1} fontWeight='bold'> M:</Grid> 
                        <Grid item xs={12} sm={6} md={11}>0756 256</Grid> 
                        <Grid item xs={12} sm={6} md={1} fontWeight='bold'> JOB:  </Grid>  
                        <Grid item xs={12} sm={6} md={2}> 30785 </Grid> 
                        <Grid item xs={12} sm={6} md={2} fontWeight='bold'>MOT Due : </Grid>
                        <Grid item xs={12} sm={6} md={1}> 05/09/2023 </Grid>
                        <Grid item xs={12} ></Grid>
                        <Grid item xs={12} > Modular Remove and Install </Grid>
                        <Grid item xs={12} ></Grid>
                        <Grid item xs={12} fontWeight='bold'> HONDA INSIGHT </Grid>

                        <Grid item xs={12}><Divider sx={{ borderBottomWidth: 5, borderColor:'black' }} /></Grid>
                        <Grid item xs={12} sm={6} md={9}fontWeight='bold'> Labour </Grid>
                        <Grid item xs={12} sm={6} md={1}><Typography variant="h6" sx={{ textDecoration: 'underline' }}> Net </Typography></Grid>
                        <Grid item xs={12} sm={6} md={1}><Typography variant="h6" sx={{ textDecoration: 'underline' }}> VAT </Typography></Grid>
                        <Grid item xs={12} sm={6} md={1}><Typography variant="h6" sx={{ textDecoration: 'underline' }}> Total </Typography></Grid>
                        <Grid item xs={12} sm={6} md={9}></Grid>
                        <Grid item xs={12} sm={6} md={1}></Grid>
                        <Grid item xs={12} sm={6} md={1}></Grid>
                        <Grid item xs={12} sm={6} md={1} p={2}></Grid>
                        <Grid item xs={12} p={1} fontWeight='bold'> Labour Total</Grid>
                        <Grid item xs={12}  ><Divider sx={{ borderBottomWidth: 5, borderColor:'black' }} /></Grid>
                        <Grid item xs={12} sm={6} md={7}fontWeight='bold'>Part</Grid>
                        <Grid item xs={12} sm={6} md={1}> <Typography variant="h6" sx={{ textDecoration: 'underline' }}>QTY</Typography></Grid>
                        <Grid item xs={12} sm={6} md={1}> <Typography variant="h6" sx={{ textDecoration: 'underline' }}>Price</Typography></Grid>
                        <Grid item xs={12} sm={6} md={1}> <Typography variant="h6" sx={{ textDecoration: 'underline' }}>Net</Typography></Grid>
                        <Grid item xs={12} sm={6} md={1}> <Typography variant="h6" sx={{ textDecoration: 'underline' }}>VAT</Typography></Grid>
                        <Grid item xs={12} sm={6} md={1} ><Typography variant="h6" sx={{ textDecoration: 'underline' }}>Total</Typography></Grid>
                        <Grid item xs={12} sm={6} md={7}></Grid>
                        <Grid item xs={12} sm={6} md={1}></Grid>
                        <Grid item xs={12} sm={6} md={1}></Grid>
                        <Grid item xs={12} sm={6} md={1}></Grid>
                        <Grid item xs={12} sm={6} md={1}></Grid>
                        <Grid item xs={12} sm={6} md={1} p={2}></Grid>
                        <Grid item xs={12} p={1} fontWeight='bold'> Part Total</Grid>
                        <Grid item xs={12}><Divider sx={{ borderBottomWidth: 5, borderColor:'black' }} /></Grid>
                        
                        <Grid item xs={12} fontWeight='bold'> Invoice Total </Grid>
                        <Grid item xs={12}></Grid>
                        <Grid item xs={12} >
                        <Box width='260px'>
                        <Grid item xs={12}>-Front left side light not working</Grid>
                        <Grid item xs={12}>-Rear right reg lamp not working</Grid>
                        <Grid item xs={12}>-Heater is not working</Grid>
                        <Grid item xs={12}>-Engine Oil cap needs replacement</Grid>
                        <Grid item xs={12}>-NSF and NSR tyre worn - 185/55/16</Grid>
                        <Grid item xs={12}>-Front suspension arms are corroded</Grid>
                        <Grid item xs={12}>-Front driver side inner track rod has play</Grid>
                        <Grid item xs={12}>-Rear coil springs are corroded</Grid>
                        <Grid item xs={12}>-Rear driver are corroded</Grid>
                        </Box>
                        </Grid>
                        <Grid item xs={12}></Grid>
                    </Grid>
                    </Box>
                  </Grid>
        
                  {/* {/* <Grid item xs={12}>
                  <HeaderBox title='PARTS' isOpen={isParts} setIsOpen={setIsParts}/>
                </Grid> */
                  /* <Grid item xs={12} >
                <SingleAccordion component={<AddPartsTable/>} title='Labour Tasks'/>
                </Grid>
                <Grid item xs={12} >
                  <SingleAccordion component={<AddPartsTable/>} title=' Spare Parts'/>
                </Grid>
                <Grid item xs={12} >
                  <SingleAccordion component={<Complaint/>} title='Suggestion'/>
                </Grid>
                <Grid item xs={12} >
                    <SingleAccordion component={<Complaint/>} title='Complaint'/>
                </Grid> */}
                </Grid> 
              </form>
            </Box>
          </Grid>
          </div>
        </Grid>
      </Box>
      
    );
  }

export default InvoiceBill
